import { useQuery } from '@tanstack/react-query';
import { SEMI_FRESH } from '../../lib/queryPresets';
import { useAuthStore } from '../../store/useAuthStore';
import { fetchCalendarSources } from '../../services/calendar/calendarService';
import {
  aggregateCalendarEvents,
  type CalendarEvent,
  type CalendarFilters,
} from '../../services/calendar/calendarAggregate';
import { withoutPrescription } from '../../lib/dossiers/dossierFields';
import { useEffectiveDossierFields } from './useCabinetSettings';

/**
 * Fetch + agrégation des événements calendrier pour le collaborateur courant.
 * Les filtres sont appliqués par la fonction pure sur le jeu déjà RLS-filtré.
 */
export function useCalendarEvents(filters: CalendarFilters): {
  events: CalendarEvent[];
  isLoading: boolean;
  isError: boolean;
} {
  const collaboratorId = useAuthStore((s) => s.collaborator?.id);

  const q = useQuery({
    ...SEMI_FRESH,
    queryKey: ['calendar', 'sources', collaboratorId ?? ''],
    queryFn: () => fetchCalendarSources(collaboratorId!),
    enabled: !!collaboratorId,
  });

  const { prescription } = useEffectiveDossierFields();
  const events = q.data
    ? withoutPrescription(
        aggregateCalendarEvents(
        q.data.dossiers,
        q.data.tasks,
        filters,
        q.data.hearings ?? [],
        q.data.appointments ?? [],
        ),
        prescription,
      )
    : [];

  return { events, isLoading: q.isLoading, isError: q.isError };
}
